define(["./dom-utils", "wfcb/amd/isAdmin"], function (domUtils, isAdmin) {
    if (isAdmin) {
        return;
    }
    var videos = document.getElementsByClassName("video-player");

    let videoAlreadyLoaded = [];
    let videoArray = [];
    let youtubeIdArray = [];
    let youtubePlayeriOScollection = [];
    let scriptYoutube = addYoutubeScript() || {};


    (function internalVideos() {

        domUtils.forEach(
            "video-player",
            ".video-player",
            function (videoPlayer) {
                if (
                    videoPlayer.classList.contains("video-autoplay") &&
                    videoPlayer.closest(".main-video")
                ) {
                    playVideo(videoPlayer, true, true);
                } else if (isiOS()) {
                    playVideo(videoPlayer, false, false);
                } else {
                    if (Array.from(videoPlayer.getElementsByTagName('button')).length) {
                        videoPlayer.getElementsByTagName('button')[0].addEventListener("click", function (event) {
                            event.preventDefault();
                            playVideo(videoPlayer, false, false);
                        });
                    }
                }
            }
        );

        function playVideo(videoPlayer, mainVideo, videoNoticia) {
            let video = videoPlayer.querySelector("video");
            let figure = videoPlayer.querySelector("figure");

            if (!video) {
                return;
            }

            if (videoAlreadyLoaded.includes(video.getAttribute("video-id"))) {
                return;
            }

            if (video.getAttribute("video-id") != null) {
                videoAlreadyLoaded.push(video.getAttribute("video-id"));
            }

            videoPlayer.classList.add("player-inline");

            let source = video.getAttribute("data-source");

            /*AdUnit shenanigans*/
            let url = window.location.href;
            let baseUrlPattern = /^https?:\/\/[a-z\:0-9.]+/;
            let result = "";

            let match = baseUrlPattern.exec(url);
            if (match != null) {
                result = match[0];
            }

            if (result.length > 0) {
                url = url.replace(result, "");
            }
            let splitUrl = url.split("/");

            let articleID = splitUrl[splitUrl.length - 2];
            splitUrl.splice(-3);
            let articleCategories = splitUrl.join("/");

            let iu = "/55964524/lv_w" + articleCategories + "/n";

            switch (source) {
                case "youtube":
                    let href = video.getAttribute("href");
                    let img = videoPlayer.querySelector("img");
                    if (!href) {
                        href = video.getAttribute("video-id");
                    }
                    //var videoWidth = video.parentElement;
                    while (!scriptYoutube) {
                        scriptYoutube = addYoutubeScript();
                    }

                    var cnfPageKeys =
                        (window.adsCfg && window.adsCfg.keys["pageKeys"]) || "";
                    var cnfD = (window.adsCfg && window.adsCfg.keys["d"]) || "";
                    var cnfSc =
                        (window.adsCfg && window.adsCfg.keys["sc"]) || "";

                    let videoEmbedConfig = {
                        adsConfig: {
                            adTagParameters: {
                                iu: iu,
                                cust_params:
                                    "id=" +
                                    articleID +
                                    "&" +
                                    "cat=story&" +
                                    "player=youtube&" +
                                    "section=" +
                                    articleCategories +
                                    "&" +
                                    "pageKeys=" +
                                    cnfPageKeys +
                                    "&" +
                                    "d=" +
                                    cnfD +
                                    "&" +
                                    "sc=" +
                                    cnfSc,
                            },
                        },
                    };

                    let videoVars = {
                        autoplay: 0,
                        mute: 0,
                        playsinline: 1,
                    };

                    if (videoNoticia) {
                        videoVars = {
                            autoplay: 0,
                            mute: 1,
                            playsinline: 1,
                        };
                    } else if (isiOS() || isMobileDevice()) {
                        videoVars = {
                            playsinline: 1,
                            autoplay: 0,
                            mute: 1
                        };
                    } else if (isTablet() && (window.matchMedia("(orientation: landscape)").matches)) {
                        mute = 1;
                    }

                    videoArray.push(video);

                    let player;

                function youTubeIframeShow() {
                    player = new YT.Player(video, {
                        width: img.width,
                        height: img.height,
                        videoId: href,
                        playerVars: videoVars,
                        events: {
                            onReady: playerReady,
                            onStateChange: stateChange,
                        }
                    });
                    figure.remove();
                }

                function youtubeIframeShowiOS() {
                    for (let i = 0; i < videoArray.length; i++) {
                        let curplayer = createNewPlayer(videoArray[i]);
                        youtubePlayeriOScollection[i] = curplayer;
                    }
                    figure.remove();
                }

                function createNewPlayer(player) {
                    return new YT.Player(player, {
                        width: "420",
                        height: "315",
                        videoId: href,
                        playerVars: videoVars,
                        events: {
                            onReady: playerReady,
                            onStateChange: stateChange,
                        },
                    });
                }

                    let currentVideoId = null;
                    let currentTime = null;
                    let currentIsMuted = null;
                    let currentIsMaximized = null;
                    let startPlay = false;
                    let startMute = true;
                    let statusYt = "";
                    let lastStatusYt = "inicial";
                    let isPlayed = false;

                function stateChange(event) {
                    let y = event.target;

                    let videoId = y.getVideoData().video_id;
                    currentVideoId = currentVideoId || videoId;

                    if (currentVideoId != videoId) {
                        logEvent(videoId, "video-next", "lv_yt_"); // TODO detect auto
                        currentVideoId = videoId;
                        currentTime = null;
                        currentIsMuted = null;
                        isPlayedYt = false;
                    }

                    if (event.data == 0) {
                        logEvent(videoId, "video-end", "lv_yt_");
                        return;
                    }

                    if (event.data == 1) {
                        let action = startPlay
                            ? "video-autoplay"
                            : "video-play";
                        if (statusYt !== "clickProgessBar" + videoId) {
                            logEvent(videoId, action, "lv_yt_"); // TODO detect auto
                            isPlayed = true;
                        }
                        startPlay = false;
                    }

                    if (event.data == 2) {
                        setTimeout(function () {
                            if (statusYt !== "clickProgessBar" + videoId) {
                                logEvent(videoId, "video-pause", "lv_yt_"); // TODO detect auto
                            } else {
                                statusYt = "";
                            }
                        }, 1500);
                    }

                    if (event.data == 3) {
                        if (
                            currentVideoId === videoId &&
                            statusYt !== lastStatusYt &&
                            isPlayed !== false
                        ) {
                            statusYt = "clickProgessBar" + videoId;
                            lastStatusYt = "clickProgessBar" + videoId;
                        }
                    }

                    {
                        let m = y.isMuted();
                        if (currentIsMuted === null) currentIsMuted = m;

                        if (currentIsMuted != m) {
                            logEvent(
                                videoId,
                                "video-" +
                                (m && startMute ? "mute" : "unmute"),
                                "lv_yt_"
                            ); // TODO detect auto
                            currentIsMuted = m;
                            startMute = true;
                        }
                    }

                    {
                        // TODO remove hack
                        let maybeWidth =
                            (
                                [].filter.call(
                                    document.getElementsByTagName("iframe"),
                                    function (u) {
                                        return (
                                            u.getAttribute("video-id") ==
                                            href
                                        );
                                    }
                                )[0] || {}
                            ).offsetWidth || 0;
                        let m =
                            ~~document.body.offsetWidth - ~~maybeWidth < 10;
                        if (currentIsMaximized === null)
                            currentIsMaximized = m;

                        if (currentIsMaximized != m) {
                            logEvent(
                                videoId,
                                "video-" + (m ? "maximize" : "minimize"),
                                "lv_yt_"
                            );
                            currentIsMaximized = m;
                        }
                    }

                    currentTime = seekTime(
                        y,
                        currentTime,
                        videoId,
                        "youtube"
                    );
                }

                function playerReady(event) {
                    window.setInterval(
                        (function (E) {
                            let e = E;
                            return function () {
                                stateChange(e);
                            };
                        })({target: event.target, data: -99}),
                        500
                    );
                    if ((isTablet() && (window.matchMedia("(orientation: landscape)").matches)) && mainVideo && videoNoticia) {
                        startPlay = true;
                        startMute = true;
                        event.target.playVideo();
                    } else if (mainVideo && videoNoticia) {
                        startPlay = true;
                        startMute = true;
                        event.target.playVideo();
                    } else if (!isiOS() && !isMobileDevice()) {
                        startPlay = false;
                        startMute = false;
                        event.target.stopVideo();
                        event.target.unMute();
                        event.target.playVideo();
                    }
                }

                    if (
                        typeof YT == "undefined" ||
                        typeof YT.Player == "undefined"
                    ) {
                        window.onYouTubePlayerAPIReady = function () {
                            //if (!isiOS()) {
                            youTubeIframeShow();
                            /*} else {
                                youtubeIframeShowiOS();
                            }*/
                        };
                    } else {
                        //if (!isiOS()) {
                        youTubeIframeShow();
                        /*} else {
                            youtubeIframeShowiOS();
                        }*/
                    }

                    break;
                default:
            }
        }
    })();

    (function embedVideos() {
        domUtils.forEach(
            "multimedia-video",
            ".multimedia-video",
            function (multimediaPlayer) {
                let iframe = multimediaPlayer.querySelector("iframe");
                if (iframe !== null) {
                    iframe.addEventListener("load", function () {
                        /*if (iframe.src.indexOf("youtube.com") !== -1) {
                        playVideoEmbed(iframe, "youtube");
                    } else*/ if (
                            iframe.src.indexOf("vimeo.com") !== -1
                        ) {
                            playVideoEmbed(iframe, "vimeo");
                        }
                    });
                }
                let div = multimediaPlayer.querySelector("div");
                if (div !== null) {
                    if (div.className === "youtube-embed") {
                        playVideoEmbed(div, "youtube");
                    } else {
                        playVideoEmbed(div, "dailymotion");
                    }
                }
            }
        );

        function playVideoEmbed(multimediaPlayer, videoType) {
            let embedVideoSrc = "";
            let embedVideoUrlParts = "";
            let videoIdEmbed = "";
            let prefix = "";
            //if (videoType === "youtube" || videoType === "vimeo") {
            if (videoType === "vimeo") {
                embedVideoSrc = multimediaPlayer.dataset.src;
                if (embedVideoSrc === undefined) {
                    embedVideoSrc = multimediaPlayer.src;
                }
                embedVideoUrlParts = embedVideoSrc.split("/");
                videoIdEmbed =
                    embedVideoUrlParts[embedVideoUrlParts.length - 1];
                prefix = "";
                if (!embedVideoSrc) {
                    return;
                }

                if (videoAlreadyLoaded.includes(videoIdEmbed)) {
                    return;
                }

                videoAlreadyLoaded.push(videoIdEmbed);
            }

            switch (videoType) {
                case "youtube":
                    /*let videoIdYoutube = videoIdEmbed.split("?");
                    videoIdYoutube = videoIdYoutube[0];*/
                    videoIdYoutube = multimediaPlayer.id;
                    youtubeIdArray.push(videoIdYoutube);
                    window.onscroll = function () {
                        youtubeIdArray.forEach((youtubeId) => {
                            let youtubeViewPortElement = document.getElementById(
                                youtubeId
                            );
                            if (isInViewport(youtubeViewPortElement)) {
                                while (!scriptYoutube) {
                                    scriptYoutube = addYoutubeScript();
                                }

                                let videoEmbedVars = {
                                    autoplay: 1,
                                    mute: 0,
                                    playsinline: 1,
                                };

                                if (isiOS()) {
                                    videoEmbedVars = {
                                        playsinline: 1,
                                        autoplay: 0,
                                    };
                                }

                                videoArray.push(multimediaPlayer);

                                let playerEmbed;

                                function onYouTubeIframeAPIReady() {
                                    playerEmbed = new YT.Player(youtubeId, {
                                        videoId: youtubeId,
                                        events: {
                                            onReady: onPlayerReady,
                                            onStateChange: onStateChangeEmbed,
                                        },
                                    });
                                }

                                function onPlayerReady(event) {
                                    window.setInterval(
                                        (function (E) {
                                            let e = E;
                                            return function () {
                                                onStateChangeEmbed(e);
                                            };
                                        })({ target: event.target, data: -99 }),
                                        500
                                    );
                                }
                                let embedCurrentTime = null;
                                let embedCurrentIsMuted = null;
                                let embedCurrentIsMaximized = null;
                                let embedStartPlay = false;
                                let embedStartMute = true;
                                function onStateChangeEmbed(event) {
                                    let embedY = event.target;
                                    switch (event.data) {
                                        case 0:
                                            logEvent(
                                                youtubeId,
                                                "video-end",
                                                "ext_yt_"
                                            );
                                            break;
                                        case 1:
                                            logEvent(
                                                youtubeId,
                                                "video-play",
                                                "ext_yt_"
                                            );
                                            break;
                                        case 2:
                                            logEvent(
                                                youtubeId,
                                                "video-pause",
                                                "ext_yt_"
                                            );
                                            break;
                                    }

                                    {
                                        let embedM = embedY.isMuted();
                                        if (embedCurrentIsMuted === null)
                                            embedCurrentIsMuted = embedM;

                                        if (embedCurrentIsMuted != embedM) {
                                            logEvent(
                                                youtubeId,
                                                "video-" +
                                                (embedM && embedStartMute
                                                    ? "mute"
                                                    : "unmute"),
                                                "ext_yt_"
                                            ); // TODO detect auto
                                            embedCurrentIsMuted = embedM;
                                            embedStartMute = true;
                                        }
                                    }

                                    {
                                        // TODO remove hack
                                        let maybeWidth =
                                            (
                                                [].filter.call(
                                                    document.getElementsByTagName(
                                                        "iframe"
                                                    ),
                                                    function (u) {
                                                        return (
                                                            /*u.getAttribute(
                                                                "video-id"
                                                            ) == youtubeId*/
                                                            u.id == youtubeId
                                                        );
                                                    }
                                                )[0] || {}
                                            ).offsetWidth || 0;
                                        let m =
                                            ~~document.body.offsetWidth -
                                            ~~maybeWidth <
                                            10;
                                        if (embedCurrentIsMaximized === null)
                                            embedCurrentIsMaximized = m;

                                        if (embedCurrentIsMaximized != m) {
                                            logEvent(
                                                youtubeId,
                                                "video-" +
                                                (m
                                                    ? "maximize"
                                                    : "minimize"),
                                                "ext_yt_"
                                            );
                                            embedCurrentIsMaximized = m;
                                        }
                                    }

                                    embedCurrentTime = seekTime(
                                        embedY,
                                        embedCurrentTime,
                                        youtubeId,
                                        "youtube",
                                        true
                                    );
                                }

                                fullScreenToggle(youtubeId, "ext_yt_");

                                if (
                                    typeof YT == "undefined" ||
                                    typeof YT.Player == "undefined"
                                ) {
                                    window.onYouTubePlayerAPIReady = function () {
                                        onYouTubeIframeAPIReady();
                                    };
                                } else {
                                    onYouTubeIframeAPIReady();
                                }

                                let index = youtubeIdArray.indexOf(youtubeId);
                                if (index > -1) {
                                    youtubeIdArray.splice(index, 1);
                                }
                            }
                        });
                    };
                    break;

                case "vimeo":
                    prefix = "ext_vimeo_";
                    addScript(
                        "https://player.vimeo.com/api/player.js",
                        function () {
                            let playerVimeo = new Vimeo.Player(
                                multimediaPlayer
                            );
                            playerVimeo.on("play", function () {
                                logEvent(videoIdEmbed, "video-play", prefix);
                            });
                            playerVimeo.on("pause", function () {
                                logEvent(videoIdEmbed, "video-pause", prefix);
                            });
                            playerVimeo.on("ended", function () {
                                logEvent(videoIdEmbed, "video-end", prefix);
                            });
                            playerVimeo.on("timeupdate", function (data) {
                                playerVimeo
                                    .getDuration()
                                    .then(function (duration) {
                                        let tt = duration;
                                        let t10p = 0.1 * tt;
                                        let t10pC = 0.1025 * tt;
                                        let t25p = 0.25 * tt;
                                        let t25pC = 0.25025 * tt;
                                        let t50p = 0.5 * tt;
                                        let t50pC = 0.5025 * tt;
                                        let t75p = 0.75 * tt;
                                        let t75pC = 0.75025 * tt;
                                        let t90p = 0.9 * tt;
                                        let t90pC = 0.9025 * tt;

                                        if (t10p < t && t < t10pC) {
                                            logEvent(
                                                videoIdEmbed,
                                                "video-10p",
                                                prefix
                                            );
                                        }

                                        if (t25p < t && t < t25pC) {
                                            logEvent(
                                                videoIdEmbed,
                                                "video-25p",
                                                prefix
                                            );
                                        }

                                        if (t50p < t && t < t50pC) {
                                            logEvent(
                                                videoIdEmbed,
                                                "video-50p",
                                                prefix
                                            );
                                        }

                                        if (t75p < t && t < t75pC) {
                                            logEvent(
                                                videoIdEmbed,
                                                "video-75p",
                                                prefix
                                            );
                                        }

                                        if (t90p < t && t < t90pC) {
                                            logEvent(
                                                videoIdEmbed,
                                                "video-90p",
                                                prefix
                                            );
                                        }
                                    });

                                let t = data.seconds;

                                if (3 < t && t < 3.25) {
                                    logEvent(videoIdEmbed, "video-3s", prefix);
                                }

                                if (10 < t && t < 10.25) {
                                    logEvent(videoIdEmbed, "video-10s", prefix);
                                }
                            });
                        }
                    );
                    break;
                case "dailymotion":
                    prefix = "ext_dailymotion_";
                    addScript("https://api.dmcdn.net/all.js", function () {
                        let idDailymotion = multimediaPlayer.id.replace(
                            "playerDailymotion",
                            ""
                        );
                        let player = DM.player(
                            document.getElementById(
                                "playerDailymotion" + idDailymotion
                            ),
                            {
                                video: idDailymotion,
                                width: "100%",
                                height: "100%",
                                params: {
                                    autoplay: false,
                                    mute: true,
                                },
                            }
                        );
                        player.addEventListener("play", function () {
                            logEvent(idDailymotion, "video-play", prefix);
                        });
                        player.addEventListener("pause", function () {
                            logEvent(idDailymotion, "video-pause", prefix);
                        });
                        player.addEventListener("end", function () {
                            logEvent(idDailymotion, "video-end", prefix);
                        });
                        player.addEventListener("timeupdate", function (data) {
                            let duration = player.duration;
                            let t = player.currentTime;
                            let t10p = 0.1 * duration;
                            let t10pC = 0.1025 * duration;
                            let t25p = 0.25 * duration;
                            let t25pC = 0.252 * duration;
                            let t50p = 0.5 * duration;
                            let t50pC = 0.505 * duration;
                            let t75p = 0.75 * duration;
                            let t75pC = 0.755 * duration;
                            let t90p = 0.9 * duration;
                            let t90pC = 0.905 * duration;

                            if (t10p < t && t < t10pC) {
                                logEvent(idDailymotion, "video-10p", prefix);
                            }

                            if (t25p < t && t < t25pC) {
                                logEvent(idDailymotion, "video-25p", prefix);
                            }

                            if (t50p < t && t < t50pC) {
                                logEvent(idDailymotion, "video-50p", prefix);
                            }

                            if (t75p < t && t < t75pC) {
                                logEvent(idDailymotion, "video-75p", prefix);
                            }

                            if (t90p < t && t < t90pC) {
                                logEvent(idDailymotion, "video-90p", prefix);
                            }

                            if (3 < t && t < 3.25) {
                                logEvent(idDailymotion, "video-3s", prefix);
                            }

                            if (10 < t && t < 10.25) {
                                logEvent(idDailymotion, "video-10s", prefix);
                            }
                        });
                    });
                    break;
            }
        }

        function fullScreenToggle(videoId, prefix) {
            document.getElementById(videoId).addEventListener(
                "fullscreenchange",
                function () {
                    if (!document.fullscreenElement) {
                        logEvent(videoId, "video-minimize", prefix);
                    } else {
                        logEvent(videoId, "video-maximize", prefix);
                    }
                },
                false
            );

            document.getElementById(videoId).addEventListener(
                "msfullscreenchange",
                function () {
                    if (!document.msFullscreenElement) {
                        logEvent(videoId, "video-minimize", prefix);
                    } else {
                        logEvent(videoId, "video-maximize", prefix);
                    }
                },
                false
            );

            document.getElementById(videoId).addEventListener(
                "mozfullscreenchange",
                function (event) {
                    if (!document.mozFullScreen) {
                        logEvent(videoId, "video-minimize", prefix);
                    } else {
                        logEvent(videoId, "video-maximize", prefix);
                    }
                },
                false
            );

            document.getElementById(videoId).addEventListener(
                "webkitfullscreenchange",
                function (event) {
                    if (!document.webkitIsFullScreen) {
                        logEvent(videoId, "video-minimize", prefix);
                    } else {
                        logEvent(videoId, "video-maximize", prefix);
                    }
                },
                false
            );
        }

        function isInViewport(element) {
            const rect = element.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <=
                (window.innerHeight ||
                    document.documentElement.clientHeight) &&
                rect.right <=
                (window.innerWidth || document.documentElement.clientWidth)
            );
        }
    })();

    function logEvent(mediaId, action, prefix) {
        if (typeof dataLayer != 'undefined') {
            dataLayer.push({
                event: "video",
                eventAction: action,
                eventLabel: prefix + mediaId,
            });
        }
    }

    function seekTime(y, currentTime, videoId, source, external = false) {
        let state = source === "youtube" ? y.getPlayerState() : y.getState();
        let getCurrentTime =
            source === "youtube" ? y.getCurrentTime() : y.getPosition();
        let prefix = source === "youtube" ? "lv_yt_" : "lv_jwp_";
        if (prefix === "lv_jwp_" && external === true) {
            prefix = "ext_jwp_";
        }
        if (prefix === "lv_yt_" && external === true) {
            prefix = "ext_yt_";
        }

        if (state === 1 || state === "playing") {
            let t = getCurrentTime || 0;
            currentTime = currentTime || t;
            let tt = y.getDuration();
            let t10p = 0.1 * tt;
            let t25p = 0.25 * tt;
            let t50p = 0.5 * tt;
            let t75p = 0.75 * tt;
            let t90p = 0.9 * tt;

            // check jumps
            if (currentTime <= 3 && 3 < t) {
                logEvent(videoId, "video-3s", prefix);
            }

            if (3 < currentTime && currentTime <= 10 && 10 < t) {
                logEvent(videoId, "video-10s", prefix);
            }

            if (currentTime <= t10p && t10p < t) {
                logEvent(videoId, "video-10p", prefix);
            }

            if (t10p < currentTime && currentTime <= t25p && t25p < t) {
                logEvent(videoId, "video-25p", prefix);
            }

            if (t25p < currentTime && currentTime <= t50p && t50p < t) {
                logEvent(videoId, "video-50p", prefix);
            }

            if (t50p < currentTime && currentTime <= t75p && t75p < t) {
                logEvent(videoId, "video-75p", prefix);
            }

            if (t75p < currentTime && currentTime <= t90p && t90p < t) {
                logEvent(videoId, "video-90p", prefix);
            }

            currentTime = t;
        } else {
            currentTime = null;
        }

        return currentTime;
    }

    function isiOS() {
        return (
            navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
        );
    }

    function isTablet() {
        navigator.platform && /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(navigator.platform)
    }


    function isMobileDevice() {
        let check = false;

        (function (a) {
            if (
                /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
                    a
                ) ||
                /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                    a.substr(0, 4)
                )
            )
                check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);

        return check;
    }

    function addYoutubeScript() {
        let tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";
        let firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        return true;
    }

    function addScript(file, callback) {
        let jsElm = document.createElement("script");
        jsElm.type = "application/javascript";
        jsElm.src = file;
        jsElm.addEventListener("load", callback);
        document.body.appendChild(jsElm);
    }

    (function moreNewsLanding() {
            $('.btn_mas-noticias-largo').on('click', function () {
                    page = $(this).attr('data-page');
                    tag = $(this).attr('data-tag');
                    userAgent = $(this).attr('data-useragent');

                    if(tag == 'ultimas-noticias'){
                        $(this).remove();
                        url = '/ultimas/article-loader/' + page;
                    }else{
                        $('.see-more-mobile').remove();
                        url = '/search/resource-mobile/' + tag + '/' + page;
                    }
                    $.get(url, function (result) {
                        if (userAgent == 'desktop') {
                            $('.notas.listing').append(result);
                        } else {
                            $('.modulo-mas-default').first().append(result);
                        }
                        window.lazyLoad();
                    });
                }
            );
        }
    )();



    var containerVideo = document.getElementsByClassName("video-overimage");

    if(typeof(containerVideo)!== "undefined" && containerVideo.length !== 0){
        $(".main-video  ").click(function () {
            containerVideo[0].style.display = "block";

        });

        containerVideo[0].style.display = "none";
    }

});
